/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {TextField} from "../../../tools/model/form/TextField";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {DeviceDTO} from "../../dto/device/DeviceDTO";

export default class DeviceForm extends AbstractForm<DeviceDTO> {

    constructor(dto?: DeviceDTO) {
        super();

        this.fields.set(DeviceDTO.NAME, new TextField(
            DeviceDTO.NAME,
            (t: Translation) => t.deviceName,
            value => value.toString().length >= 0,
            Type.TEXT,
            false,
            "",
            ""
        ));

        this.fields.set(DeviceDTO.UUID, new TextField(
            DeviceDTO.UUID,
            (t: Translation) => t.uuid,
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        if (dto) super.load(dto);
    }
}
